import fp from 'lodash/fp';

export const getRoot = fp.get('impactchart');

export const getInitialised = fp.flow(
    getRoot,
    fp.get('initialised')
);

export const getData = fp.flow(
    getRoot,
    fp.get('data')
);

export const getTimeLastUpdated = fp.flow(
    getRoot,
    fp.get('timeLastUpdated')
);

export const getFetching = fp.flow(
    getRoot,
    fp.get('fetching')
);

export const getError = fp.flow(
    getRoot,
    fp.get('error')
);

export const getUseDollars = fp.flow(
    getRoot,
    fp.get('useDollars')
);

export const getSorting = (state) => {
    const stateSorting = fp.flow(
        getRoot,
        fp.getOr([], 'sorting')
    )(state);

    return stateSorting.map(grid => fp.set(
        'gridSort',
        grid.gridSort.map(col => ({
            ...col,
            id: col.id.replace('**CURRENCY**', getUseDollars(state) ? 'Usd' : 'Eur')
        }))
    )(grid));
};
